import script from "./GroupWordsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupWordsBlock.vue?vue&type=script&setup=true&lang=js"

import "./GroupWordsBlock.vue?vue&type=style&index=0&id=ef6acc02&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef6acc02"]])

export default __exports__